// eslint-disable-next-line no-unused-vars
import ajax, { skk_axios as axios } from "@/common/ajax.js";
// /**
//  * //发送短信
//  * @param {*} params
//  * @returns
//  */
// export const get_code = (params) => {
//   return axios({
//     url: "/api/common/getCodeCaptcha",
//     method: "get",
//     params,
//   });
// };
// 信息登记 获取专职人员列表
export function get_code(data) {
  return ajax.request.post("/api/common/getCodeCaptcha", data);
}

/**
 * 获取经济类型列表
 * @param {*} params
 * @returns
 */
export const comEcoList = (params) => {
  return axios({
    url: "/api/common/comEcoList",
    method: "get",
    params,
  });
};

/**
 * 下载文件
 * @param {*} params
 * @returns
 */
export const download = (params) => {
  return axios({
    url: "/api/common/download",
    method: "get",
    params,
  });
};

/**
 * 读取用户上传的业绩
 * @param {*} params
 * @returns
 */
export const getUploadYj = (params) => {
  return axios({
    url: "/api/project/upload",
    method: "get",
    params,
  });
};
